module.exports = __webpack_public_path__ + "img/undraw_notes_re_pxhw.625184c2.svg";